export function getAuthorName(
  user?: {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
  } | null,
  fallback: string | null = null,
): string | null {
  return user?.firstName && user?.lastName
    ? `${user?.firstName} ${user?.lastName}`
    : (user?.email ?? fallback);
}
